import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

/* assets */
import HeaderBgMob from 'public/assets/gml-2025/gml-ip-hero-bg-mob.png'
import HeaderBgMed from 'public/assets/gml-2025/gml-ip-hero-bg-med.png'
import HeaderBgDesk from 'public/assets/gml-2025/gml-ip-hero-bg.png'
import { ReactComponent as InstagramIcon } from 'public/assets/influencer/icons/social/Instagram.svg'
import { ReactComponent as TwitterIcon } from 'public/assets/influencer/icons/social/Twitter.svg'
import { ReactComponent as LinkedInIcon } from 'public/assets/influencer/icons/social/Linkedin.svg'

/* styles */
import styles from '../../_.module.css'

interface Props {
  quote: string
  name: string
  companyName: string
  designation: string
  profileImage: StrapiImageFile
  linkedinLink: string
  instagramLink: string
  twitterLink: string
}

const IndividualPageHero = ({
  quote,
  name,
  companyName,
  designation,
  profileImage,
  linkedinLink,
  instagramLink,
  twitterLink
}: Props) => {
  return (
    <section className="relative text-white">
      <Image
        src={HeaderBgMob.src}
        alt=""
        width={HeaderBgMob.width}
        height={HeaderBgMob.height}
        className="block md:hidden w-full"
        priority
      />
      <Image
        src={HeaderBgMed.src}
        alt=""
        width={HeaderBgMed.width}
        height={HeaderBgMed.height}
        className="hidden md:block lg:hidden w-full"
        priority
      />
      <Image
        src={HeaderBgDesk.src}
        alt=""
        width={HeaderBgDesk.width}
        height={HeaderBgDesk.height}
        className="hidden lg:block w-full"
        priority
      />
      <div className="container absolute inset-0 flex items-end justify-center">
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-7">
          <div className="flex flex-col justify-center | order-1 lg:order-2 | md:px-14 lg:px-0">
            <h1
              className="text-2xl lg:text-3xl | mb-5 md:mb-9"
              dangerouslySetInnerHTML={{ __html: quote }}
            />
            <div className="flex align-middle gap-4 items-center | mb-2">
              <h3
                className="font-body font-semibold text-base lg:text-2xl"
                dangerouslySetInnerHTML={{ __html: name }}
              />
              <div>|</div>
              <div className="flex gap-4 lg:col-start-9 lg:col-end-12">
                {linkedinLink ? (
                  <Link
                    href={linkedinLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedInIcon
                      color={'#FFFFFF'}
                      className="w-4 h-4 md:w-5 md:h-5"
                    />
                  </Link>
                ) : null}

                {twitterLink ? (
                  <Link
                    href={twitterLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <TwitterIcon
                      color={'#FFFFFF'}
                      className="w-4 h-4 md:w-5 md:h-5"
                    />
                  </Link>
                ) : null}

                {instagramLink ? (
                  <Link
                    href={instagramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InstagramIcon
                      color={'#FFFFFF'}
                      className="w-4 h-4 md:w-5 md:h-5"
                    />
                  </Link>
                ) : null}
              </div>
            </div>

            <div className="flex flex-wrap">
              <p
                className={clsx(
                  'font-body text-small lg:text-lg | mr-1',
                  styles.designation
                )}
                dangerouslySetInnerHTML={{ __html: designation }}
              />
              <p
                className="font-body font-semibold text-small lg:text-lg"
                dangerouslySetInnerHTML={{ __html: companyName }}
              />
            </div>
          </div>
          <Image
            className="md:max-w-sm lg:max-w-md xl:max-w-[569px] mx-auto | order-2 lg:order-1"
            src={profileImage.url}
            alt={profileImage.alternativeText ?? ''}
            width={profileImage.width}
            height={profileImage.height}
            priority
          />
        </div>
      </div>
    </section>
  )
}

export default IndividualPageHero
